<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="sAPShipmentInvoices/getMiddleWarePage"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNum" clearable/>
          </vm-search>
          <vm-search label="发货单号">
            <el-input v-model.trim="filter.invoiceNo" clearable/>
          </vm-search>
          <vm-search label="销售单号">
            <el-input v-model.trim="filter.salesOrder" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.purchaseUnit" clearable/>
          </vm-search>
        </div>
        <div class="vm-search">
          <vm-search label="项目名称">
            <el-input v-model.trim="filter.projectName" clearable/>
          </vm-search>
          <vm-search label="跟踪信息">
            <el-select v-model.trim="filter.trackingNote" clearable placeholder="请选择">
              <el-option label="有" value="有"/>
              <el-option label="无" value="无"/>
            </el-select>
          </vm-search>
          <vm-search label="发运状态">
            <el-select v-model.trim="filter.completeEndState" clearable placeholder="请选择">
              <el-option label="未发运" value="未发运"/>
              <el-option label="已发运" value="已发运"/>
            </el-select>
          </vm-search>
          <vm-search label="接收状态">
            <el-select v-model.trim="filter.receiveStatus" clearable placeholder="请选择">
              <el-option label="未接收" value="未接收"/>
              <el-option label="已接收" value="已接收"/>
            </el-select>
          </vm-search>
        </div>
        <div class="vm-search">
          <vm-search label="包装类别">
            <el-select v-model.trim="filter.maxMinPacking" clearable placeholder="请选择">
              <el-option label="大包装" value="大包装"/>
              <el-option label="小包装" value="小包装"/>
            </el-select>
          </vm-search>
          <vm-search label="包装状态">
            <el-select v-model.trim="filter.packingState" clearable placeholder="请选择">
              <el-option label="未包装" value="未包装"/>
              <el-option label="已包装" value="已包装"/>
            </el-select>
          </vm-search>
          <vm-search label="出料状态">
            <el-select v-model.trim="filter.printStatus" clearable placeholder="请选择">
              <el-option label="未出料" value="未出料"/>
              <el-option label="已出料" value="已出料"/>
            </el-select>
          </vm-search>
          <vm-search label="过账状态">
            <el-select v-model.trim="filter.postingStatus" clearable placeholder="请选择">
              <el-option label="A" value="A"/>
              <el-option label="C" value="C"/>
              <el-option label="NULL" value="NULL"/>
            </el-select>
          </vm-search>
        </div>
        <vm-search label="包装日期">
          <div class="block">
            <el-date-picker
                v-model="filter.packingDateBegin"
                value-format="yyyy-MM-dd 00:00:00"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.packingDateEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="发货交期">
          <div class="block">
            <el-date-picker
                v-model="filter.invoiceTimeBegin"
                value-format="yyyy-MM-dd 00:00:00"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.invoiceTimeEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="出料日期">
          <div class="block">
            <el-date-picker
                v-model="filter.printDateBegin"
                value-format="yyyy-MM-dd 00:00:00"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.printDateEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="接收日期">
          <div class="block">
            <el-date-picker
                v-model="filter.receiveDateBegin"
                value-format="yyyy-MM-dd 00:00:00"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.receiveDateEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="实发日期">
          <div class="block">
            <el-date-picker
                v-model="filter.completeEndDateBegin"
                value-format="yyyy-MM-dd 00:00:00"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.completeEndDateEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="过账日期">
          <div class="block">
            <el-date-picker
                v-model="filter.postingTimeBegin"
                value-format="yyyy-MM-dd 00:00:00"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.postingTimeEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
      </template>
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table :data="scope.row.sapShipmentInvoiceDetailList">
            <el-table-column label="产品代码" align="center" prop="code" width="100"/>
            <el-table-column label="产品名称" align="center" prop="productName" width="400"/>
            <el-table-column label="数量" align="center" prop="numbers" width="65"/>
            <el-table-column label="单位" align="center" prop="units" width="55"/>
            <el-table-column label="备注" align="center" prop="remarks" width="500"/>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column align="center" prop="status" label="状态" width="50">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 2107">正常</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="priority" label="级别" width="50">
        <template slot-scope="scope">
          <span v-if="scope.row.priority === 1" style="color: red">优先</span>
          <span v-else>正常</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="isImportant" label="标记" width="50">
        <template slot-scope="scope">
          <span v-if="scope.row.isImportant !== null && scope.row.isImportant > 0" style="color: red">重要</span>
          <span v-else>正常</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="packingState" label="包装状态" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.packingState === '未包装'">未包装</span>
          <span v-if="scope.row.packingState === '已包装'">已包装</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="maxMinPacking" label="包装类别" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.maxMinPacking === '大包装'">大包装</span>
          <span v-if="scope.row.maxMinPacking === '小包装'">小包装</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="projectName" label="项目名称" width="280"/>
      <el-table-column align="center" prop="purchaseUnit" label="客户名称" width="240"/>
      <el-table-column align="center" prop="employeeName" label="制单人" width="60"/>
      <el-table-column align="center" prop="clientContractNO" label="SAP合同号" width="90"/>
      <el-table-column align="center" prop="salesOrder" label="销售订单" width="90">
        <!--        <template slot-scope="scope">-->
        <!--          <span @click="getSalesOrder(scope.row)">{{scope.row.salesOrder}}</span>-->
        <!--        </template>-->
      </el-table-column>
      <el-table-column align="center" prop="factoryNo" label="出厂编号" width="90"/>
      <el-table-column align="center" prop="invoiceNo" label="发货单号" width="90"/>
      <el-table-column align="center" prop="planDeliveryDate" label="计划交期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.planDeliveryDate.substring(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="invoiceTime" label="发货交期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.invoiceTime.substring(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="finalDeliveryDate" label="计划调整交期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.finalDeliveryDate.substring(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="kZG" label="控制柜"/>
      <el-table-column align="center" prop="cOP" label="操纵箱"/>
      <el-table-column align="center" prop="lOP" label="召唤盒"/>
      <el-table-column align="center" prop="jDH" label="轿顶盒"/>
      <el-table-column align="center" prop="wJB" label="微机板"/>
      <el-table-column align="center" prop="xL" label="线缆"/>
      <el-table-column align="center" prop="bJTwo" label="部件204"/>
      <el-table-column align="center" prop="dZX" label="电阻箱"/>
      <el-table-column align="center" prop="jQRKZG" label="机器人控制柜" width="100"/>
      <el-table-column align="center" prop="yTJ" label="一体机"/>
      <el-table-column align="center" prop="jPD" label="简配单A"/>
      <el-table-column align="center" prop="status" label="订单状态" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 2107">正常</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="responseContent" label="最后完成时间" width="135"/>
      <el-table-column align="center" prop="printDate" label="出料时间" width="135"/>
      <el-table-column align="center" prop="replyDeliveryDate" label="电机回复交期" width="135"/>
      <el-table-column align="center" prop="receiveDate" label="接收时间" width="135"/>
      <el-table-column align="center" prop="packingDate" label="包装时间" width="135"/>
      <el-table-column align="center" prop="completeEndDate" label="发运时间" width="135"/>
      <el-table-column align="center" prop="bjComplete" label="部件料齐扫描" width="100"/>
      <el-table-column align="center" prop="totalAmount" label="金额" width="55"/>
      <el-table-column align="center" prop="trackingNote" label="跟踪信息" width="300"/>
      <el-table-column align="center" prop="postingStatus" label="过账状态" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.postingStatus === 'A'">未过账</span>
          <span v-if="scope.row.postingStatus === 'B'">部分过账</span>
          <span v-if="scope.row.postingStatus === 'C'">已过账</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="postingTime" label="过账时间" width="85"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  export default {
    name: "MiddleWarehouseList",
    components: {VmTable,VmSearch},
    data() {
      return {
        filter: {
          factoryNum: "",
          invoiceNo: "",
          salesOrder: "",
          status: "",
          completeEndState: "",
          purchaseUnit: "",
          projectName: "",
          trackingNote: "",
          maxMinPacking: "",
          packingState: "",
          printStatus: "",
          postingStatus: "",

          packingDateBegin:"",
          packingDateEnd:"",
          invoiceTimeBegin:"",
          invoiceTimeEnd:"",
          printDateBegin:"",
          printDateEnd:"",
          receiveDateBegin:"",
          receiveDateEnd:"",
          completeEndDateBegin:"",
          completeEndDateEnd:"",
          postingTimeBegin:"",
          postingTimeEnd:"",

          receiveStatus:"",
        },
        idList:[],
      };
    },
    mounted() {
      this.initTime();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      initTime() {
        this.filter.invoiceTimeEnd = this.getFormatDate(new Date());
        this.filter.invoiceTimeBegin = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29));
        this.getList(1);
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      getSalesOrder(row) {
        console.log(row);
        this.$router.push({
          path: "/salesOrder",
          query: {
            billType: 1,
            billId: row.pkid,
            $tabName: row.salesOrderNO,
          },
        });
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","sAPShipmentInvoices/exportMiddleWareHouse", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style scoped>

</style>
